import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { Tablero as Datos } from "../../../../services/v2/telefonia.service";
import { Aviso, errorTexto, minutos, num, pct, plantelNombre, seg } from "./comunes";
import { Compartido } from "./telefoniaController";

const hoy = () => new Date();
const iso = (d: Date) => d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
const menos = (n: number) => { const d = hoy(); d.setDate(d.getDate() - n); return d; };
export const PERIODOS: { k: string; t: string; desde: () => string; hasta: () => string }[] = [
	{ k: "hoy", t: "Hoy", desde: () => iso(hoy()), hasta: () => iso(hoy()) },
	{ k: "ayer", t: "Ayer", desde: () => iso(menos(1)), hasta: () => iso(menos(1)) },
	{ k: "7", t: "7 días", desde: () => iso(menos(6)), hasta: () => iso(hoy()) },
	{ k: "30", t: "30 días", desde: () => iso(menos(29)), hasta: () => iso(hoy()) },
	{ k: "mes", t: "Este mes", desde: () => iso(new Date(hoy().getFullYear(), hoy().getMonth(), 1)), hasta: () => iso(hoy()) },
];

/** Selector de periodo + plantel que comparten Tablero y Llamadas. */
export const Periodo: React.FC<{ f: any; setF: (f: any) => void; planteles: { id: number; name: string }[] }> = ({ f, setF, planteles }) => {
	const [k, setK] = useState<string>("hoy");
	return (
		<div className="tf-filtros">
			<div className="tf-periodos">
				{PERIODOS.map((p) => <button key={p.k} className={k === p.k ? "on" : ""} onClick={() => { setK(p.k); setF({ ...f, desde: p.desde(), hasta: p.hasta() }); }}>{p.t}</button>)}
			</div>
			<div className="tf-campo"><label>Desde</label><input type="date" value={f.desde} onChange={(e) => { setK(""); setF({ ...f, desde: e.target.value }); }} /></div>
			<div className="tf-campo"><label>Hasta</label><input type="date" value={f.hasta} onChange={(e) => { setK(""); setF({ ...f, hasta: e.target.value }); }} /></div>
			{planteles.length > 1 ? (
				<div className="tf-campo"><label>Plantel</label>
					<select value={f.campus_id || ""} onChange={(e) => setF({ ...f, campus_id: e.target.value ? Number(e.target.value) : "" })}>
						<option value="">Todos</option>{planteles.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
					</select>
				</div>
			) : null}
		</div>
	);
};

const Tablero: React.FC<{ sh: Compartido }> = ({ sh }) => {
	const http = HttpManager.getInstance();
	const [f, setF] = useState<any>({ desde: iso(hoy()), hasta: iso(hoy()), campus_id: "" });
	const [d, setD] = useState<Datos | null>(null);
	const [error, setError] = useState<string | null>(null);
	useEffect(() => {
		http.telefoniaService.tablero(sh.campusId, f).then((r) => setD(r.data)).catch((e) => setError(errorTexto(e)));
	}, [sh.campusId, f.desde, f.hasta, f.campus_id]);

	const k = d?.kpi;
	const maxH = Math.max(1, ...(d?.porHora || []).map((h) => h.total));
	const horas = (d?.porHora || []).filter((h) => h.h >= 6 && h.h <= 21);
	const maxD = Math.max(1, ...(d?.porDia || []).map((x) => x.total));
	const hora12 = (h: number) => (h % 12 || 12) + (h < 12 ? "am" : "pm");

	return (
		<>
			<Periodo f={f} setF={setF} planteles={sh.cat.planteles} />
			<Aviso texto={error} onClose={() => setError(null)} />
			{k ? (
				<div className="tf-kpis">
					<div className="nu-kpi"><span>Llamadas</span><b>{num(k.total)}</b><small>{num(k.salientes)} salientes · {num(k.entrantes)} entrantes</small></div>
					<div className="nu-kpi"><span>Contestadas</span><b>{pct(k.contestadas, k.total)}</b><small>{num(k.contestadas)} de {num(k.total)}</small></div>
					<div className="nu-kpi"><span>Tiempo hablado</span><b>{minutos(k.hablado)}</b><small>promedio {seg(k.promedio)} por llamada</small></div>
					<div className={"nu-kpi" + (Number(k.perdidas) ? " oro" : "")}><span>Entrantes perdidas</span><b>{num(k.perdidas)}</b><small>{num(k.abandonadas)} colgaron esperando · {num(k.vencidas)} sin contestar</small></div>
					<div className="nu-kpi"><span>Espera en cola</span><b>{k.espera !== null ? Math.round(Number(k.espera)) + " s" : "–"}</b><small>máxima {k.espera_max !== null ? Math.round(Number(k.espera_max)) + " s" : "–"}</small></div>
					<div className="nu-kpi"><span>Asesoras activas</span><b>{num(k.asesoras)}</b><small>{num(k.grabadas)} grabaciones</small></div>
				</div>
			) : null}
			<div className="tf-rejilla">
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Por hora del día <small>hora de México</small></div>
					<div className="tf-barras">
						{horas.map((h) => (
							<div key={h.h} className="tf-barra" title={h.total + " llamadas, " + h.contestadas + " contestadas"}>
								{h.total ? <em>{h.total}</em> : null}
								<i style={{ height: Math.round((100 * (h.total - h.contestadas)) / maxH) + "%" }} />
								<i className="ok" style={{ height: Math.round((100 * h.contestadas) / maxH) + "%" }} />
								<small>{hora12(h.h)}</small>
							</div>
						))}
					</div>
					<div className="tf-leyenda"><span><i className="ok" />Contestadas</span><span><i />No contestadas</span></div>
				</div>
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Por día</div>
					{(d?.porDia || []).length > 1 ? (
						<div className="tf-barras">
							{d!.porDia.map((x) => (
								<div key={x.d} className="tf-barra" title={x.d + ": " + x.total + " llamadas, " + x.contestadas + " contestadas"}>
									{x.total ? <em>{x.total}</em> : null}
									<i style={{ height: Math.round((100 * (x.total - x.contestadas)) / maxD) + "%" }} />
									<i className="ok" style={{ height: Math.round((100 * x.contestadas) / maxD) + "%" }} />
									<small>{x.d.slice(8)}/{x.d.slice(5, 7)}</small>
								</div>
							))}
						</div>
					) : <div className="nu-vacio">Elige más de un día para ver la tendencia.</div>}
				</div>
			</div>
			<div className="tf-rejilla tres" style={{ marginTop: 14 }}>
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Por asesora</div>
					<div className="nu-tabla-scroll" style={{ maxHeight: 460 }}>
						<table className="nu-tabla">
							<thead><tr><th>Asesora</th><th className="izq">Equipo</th><th>Llamadas</th><th>Salientes</th><th>Entrantes</th><th>Contestadas</th><th>%</th><th>Hablado</th><th>Promedio</th><th>Buzón</th><th>Equivocado</th><th>Primera</th><th>Última</th></tr></thead>
							<tbody>
								{(d?.porAsesora || []).map((a) => (
									<tr key={a.extension}>
										<td>{a.name || a.extension} <span className="nu-tenue">· {a.extension}</span></td><td className="izq">{a.team || "–"}</td>
										<td>{num(a.total)}</td><td>{num(a.salientes)}</td><td>{num(a.entrantes)}</td><td>{num(a.contestadas)}</td><td>{pct(a.contestadas, a.total)}</td>
										<td>{minutos(a.hablado)}</td><td>{seg(a.promedio)}</td><td>{num(a.r_buzon)}</td><td>{num(a.r_equivocado)}</td>
										<td>{new Date(a.primera.replace(" ", "T") + "Z").toLocaleTimeString("es-MX", { hour: "numeric", minute: "2-digit", hour12: true }).replace(/p\.\s?m\./, "pm").replace(/a\.\s?m\./, "am")}</td>
										<td>{new Date(a.ultima.replace(" ", "T") + "Z").toLocaleTimeString("es-MX", { hour: "numeric", minute: "2-digit", hour12: true }).replace(/p\.\s?m\./, "pm").replace(/a\.\s?m\./, "am")}</td>
									</tr>
								))}
								{!d?.porAsesora.length ? <tr><td colSpan={13} className="nu-vacio">Sin llamadas en este periodo.</td></tr> : null}
							</tbody>
						</table>
					</div>
				</div>
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Departamentos (entrantes)</div>
					<table className="nu-tabla">
						<thead><tr><th>Departamento</th><th>Entraron</th><th>Contestadas</th><th>Perdidas</th><th>Espera</th><th>≤20 s</th></tr></thead>
						<tbody>
							{(d?.porDepartamento || []).map((q) => (
								<tr key={q.queue_code}><td>{q.name || q.queue_code}</td><td>{num(q.total)}</td><td>{num(q.contestadas)}</td><td>{num(Number(q.abandonadas) + Number(q.vencidas))}</td>
									<td>{q.espera !== null ? Math.round(Number(q.espera)) + " s" : "–"}</td><td>{pct(q.en20, q.contestadas)}</td></tr>
							))}
							{!d?.porDepartamento.length ? <tr><td colSpan={6} className="nu-vacio">Sin llamadas por departamento.</td></tr> : null}
						</tbody>
					</table>
					<div className="nu-bloque-tit chico">Por plantel</div>
					<table className="nu-tabla">
						<thead><tr><th>Plantel</th><th>Llamadas</th><th>Contestadas</th><th>Hablado</th></tr></thead>
						<tbody>
							{(d?.porPlantel || []).map((p) => (
								<tr key={String(p.campus_id)}><td>{plantelNombre(sh.cat, p.campus_id) === "Todos" ? "Sin plantel" : plantelNombre(sh.cat, p.campus_id)}</td><td>{num(p.total)}</td><td>{pct(p.contestadas, p.total)}</td><td>{minutos(p.hablado)}</td></tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</>
	);
};

export default Tablero;
